import { render, staticRenderFns } from "./TemplateOrderMulti.vue?vue&type=template&id=b609b500&scoped=true"
import script from "./TemplateOrderMulti.vue?vue&type=script&lang=js"
export * from "./TemplateOrderMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b609b500",
  null
  
)

export default component.exports